export default __webpack_public_path__ + "static/media/2.d822eb6e.mp3";